import { toaster } from "components";

interface ToastOptions {
  title?: string;
  description?: string;
  status?: "success" | "error" | "warning" | "info";
  duration?: number;
  isClosable?: boolean;
}

const statusTypeMap = {
  success: "success",
  error: "error",
  warning: "warning",
  info: "info",
} as const;

export const useToast = () => {
  return (options: ToastOptions) => {
    toaster.create({
      title: options.title,
      description: options.description,
      type: statusTypeMap[options.status ?? "info"],
      duration: options.duration ?? 5000,
      closable: options.isClosable ?? true,
    });
  };
};
